import { Typography, TypographyProps } from "@mui/material";
import React from "react";

export const ClipTypography = (props: TypographyProps) => (
    <Typography
        textOverflow="clip"
        overflow="hidden"
        whiteSpace="nowrap"
        {...props}
    >
        {props.children}
    </Typography>
);
